import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex p-3 items-center space-x-2" }
const _hoisted_2 = { class: "flex-grow text-sm overflow-hidden" }
const _hoisted_3 = { class: "font-medium ct-text-1 truncate" }
const _hoisted_4 = { class: "ct-text-3 truncate" }

import { CardHoverLink } from "@easy/ui/cards";

export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectCard',
  props: {
    icon: {},
    image: {},
    isSelected: { type: Boolean },
    name: {},
    subtitle: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["cursor-pointer ring-1 ring-inset p-2 ct-bg-1--alt rounded-lg shadow-sm shadow-gray-900/5", [_ctx.isSelected ? 'ct-ring-brand' : 'ct-ring-1 hover:ct-ring-brand cursor-pointer']])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(CardHoverLink), {
        src: _ctx.image,
        icon: _ctx.icon,
        class: "flex-shrink-0"
      }, null, 8, ["src", "icon"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.name), 1),
        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.subtitle), 1)
      ])
    ]),
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})